
import * as Const from '../../shared/constants';

import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

// servicios 
import { EntradasService } from 'src/app/services/datos/entradas.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { ClientesService } from 'src/app/services/datos/clientes.service';

// interfaces
import { ICliente } from 'src/app/interfaces/cliente';

// librerías
import { ActivatedRoute, Router } from '@angular/router';
import { IAlmacen } from 'src/app/interfaces/almacenes';
import { UsuarioService } from 'src/app/services/datos/usuario.service';
import { IEntrada } from 'src/app/interfaces/entrada';

@Component({
  selector: 'app-entrada-directa',
  templateUrl: './entrada-directa.component.html',
  styleUrls: ['./entrada-directa.component.scss']
})

export class EntradaDirectaComponent implements OnInit {

  // Usar constantes en el template
  Const = Const

  public cliente: ICliente = {}
  public clientesList: ICliente[] = [];
  public entradaCabeceraForm: FormGroup = new FormGroup({});
  public almacenPorDefecto: IAlmacen = {};

  public enviado: boolean = false;
  public loading: boolean = false;

  constructor(
    private entradaSrv: EntradasService,
    public notifciSrv: NotificacionesService,
    private clientesSrv: ClientesService,
    private usrSrv: UsuarioService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {

    // declarar formularios de cabecera y detalle

    this.entradaCabeceraForm = this.fb.group({
      id_cliente: ['', Validators.required],
      albaran: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(150)]],
    });

    this.getClientesList();

  }

  // Lista de clientes 
  getClientesList() {
    this.loading = true;
    this.clientesSrv.getLista().subscribe((resp) => {
      this.loading = false;
      this.clientesList = resp.data.filter(
        (cliente: { archivado: boolean }) => !cliente.archivado
      );
      console.log('__getClientesList() clientesList:', this.clientesList);
    });
  }


  getAlmacenPorDefecto() {
    this.almacenPorDefecto = {};
    const id_cliente = this.entradaCabeceraForm.value.id_cliente;
    if (!id_cliente) {
      return;
    }
    this.clientesSrv.getCliente(id_cliente).subscribe((resp) => {
      if (resp.error) {
        this.notifciSrv.aviso('error', resp.mensaje);
        return;
      }
      this.almacenPorDefecto = resp.totales.alm_por_defecto;
    });
  }


  enviar() {
    // Enviar datos
    this.enviado = true;

    if (this.entradaCabeceraForm.invalid) {
      console.log('ERRORES:', this.entradaCabeceraForm);
      return;
    }

    // Todo ok, enviar al BackEnd 
    const data: IEntrada = {
      action: 'new',
      id_cliente: this.entradaCabeceraForm.value.id_cliente,
      id_almacen: Number(this.almacenPorDefecto.id),
      ubiPlaya: this.almacenPorDefecto.ubiPlaya,
      albaran: this.entradaCabeceraForm.value.albaran,
      username: this.usrSrv.userdata.username,
      pales: 0,
      origen: Const.ENTRADA_ORIGEN_ADMINISTRADOR,
      swEntradaDirecta: '1',
    }

    this.loading = true;
    this.entradaSrv.new(data).subscribe((resp) => {
      console.log('__enviarCabecera() resp:', resp);
      this.loading = false;
      if (resp.error) {
        this.notifciSrv.aviso('error', resp.mensaje);
        return;
      }
      this.notifciSrv.aviso('success', resp.mensaje);
      if (resp.totales.id_entrada) {
        this.router.navigate(['/pda/entrada_directa_detall', resp.totales.id_entrada]);
      } else {
        this.router.navigate(['/pda']);
      }
    });
    console.log('__enviarCabecera() data:', data);
    this.loading = false;

    return
  }


  ////// AUX ///// 

  get f() {
    return this.entradaCabeceraForm.controls;
  }

  toUpper(fieldName: string) {
    const formControl = this.f[fieldName];

    if (formControl && formControl.value) {
      formControl.setValue(formControl.value.toUpperCase());
    }
  }


}
